import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import TrainingShell from './training-module/TrainingShell.jsx'
import FoodPlanShell from './food-plan/FoodPlanShell.jsx'
import DemoApp from './demo/DemoApp.jsx'
import { AuthProvider } from './context/AuthContext.jsx'
import { TenantProvider } from './context/TenantContext.jsx'
import { I18nProvider } from './context/I18nContext.jsx'
import { FrontendConfigProvider } from './context/FrontendConfigContext.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx'
import { BrowserRouter, useLocation } from 'react-router-dom'
import { isFoodPublicExternalOnly, FOOD_PUBLIC_LOGIN_URL } from './utils/foodModule.js'
import { isFoodPublicPath } from './utils/foodPublicBrand.js'

function AppErrorShell({ children }) {
  const location = useLocation();
  return (
    <ErrorBoundary resetKey={location.pathname + location.search}>
      {children}
    </ErrorBoundary>
  );
}

const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
const onFoodPlanPath = isFoodPublicPath(pathname);
const onTrainingModulePath = pathname.startsWith('/training-module');
const onDemoPath = pathname === '/demo' || pathname.startsWith('/demo/');

// Rollback: VITE_FOOD_EXTERNAL=true → foodplan.tech
if (typeof window !== 'undefined' && onFoodPlanPath && isFoodPublicExternalOnly()) {
  window.location.replace(FOOD_PUBLIC_LOGIN_URL);
}

const shellTree = (
  <I18nProvider>
    <FrontendConfigProvider>
      <AuthProvider>
        <TenantProvider>
          <AppErrorShell>
            <App />
          </AppErrorShell>
        </TenantProvider>
      </AuthProvider>
    </FrontendConfigProvider>
  </I18nProvider>
);

/** Demo publicitario: sin Auth/API (Docker no requerido). */
const demoTree = (
  <BrowserRouter>
    <ErrorBoundary resetKey={pathname}>
      <DemoApp />
    </ErrorBoundary>
  </BrowserRouter>
);

async function bootstrap() {
  if (onFoodPlanPath && isFoodPublicExternalOnly()) {
    return;
  }

  await import('./index.css');

  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      {onDemoPath ? (
        demoTree
      ) : onFoodPlanPath ? (
        <FoodPlanShell />
      ) : onTrainingModulePath ? (
        <TrainingShell />
      ) : (
        <BrowserRouter>{shellTree}</BrowserRouter>
      )}
    </React.StrictMode>,
  );
}

bootstrap();
